var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1950 587.82v537.18h900.74c165.28 0 299.26 134.18 299.26 299.11v1801.8c0 165.2-133.89 299.11-299.26 299.11h-2101.5c-165.28 0-299.26-134.18-299.26-299.11v-1801.8c0-165.2 133.89-299.11 299.26-299.11h900.74v-537.67l-169.42 169.42c-58.039 58.035-152.17 58.008-211.16-0.98047-58.578-58.578-58.23-153.9-0.97656-211.15l426.22-426.22c28.859-28.855 66.641-43.359 104.59-43.395l1.1445 0.44922c38.094 0.078125 75.973 14.48 104.44 42.945l426.22 426.22c58.039 58.039 58.008 152.17-0.98047 211.15-58.578 58.578-153.9 58.234-211.15 0.98047zm-300 837.18h-900v1800h2100v-1800h-900v600.23c0 82.715-66.578 149.77-150 149.77-82.844 0-150-67.125-150-149.77zm-450-300v300h1200v-300zm450 0h300v300h-300z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.83821334da1721b54d5f1fb88144f8a2.svg";
export { ForwardRef as ReactComponent };